<template>
    <div>
      <nav-breadcrumb :menu="[{label: customerId ? '编辑核心企业' : '新增核心企业'}]"/>
      <company-edit-component :data.sync="debtorForm" @onSubmit="onSubmit"></company-edit-component>
      <button-back/>
  </div>
</template>

<script>
  import CompanyEditComponent from '../../components/CompanyEditComponent'
  import FormBuild from '../../../components/FormBuild'
  import xhr from '../../../utils/xhr'
  import Panel from '../../../components/Panel'
  import ButtonBack from "../../../components/ButtonBack";
  import {CodeToText, TextToCode} from "element-china-area-data";

  export default {
    name: "ConfigDebtorEdit",
    data() {
      return {
        debtorForm: {
          "u__email": "",
          "c__customerName": "",
          "c__customerCode": "",
          "i__provinceAndCity": [],
          "i__province": "",
          "i__city": "",
          "i__address": "",
          "i__socialIdentityCode": "",
          "i__registeredCapital": "",
          "i__bizlicValidity": [],
          // "i__bizlicValidity1": "",
          // "i__bizlicValidity2": "",
          "i__bizlicURL": "",
          "i__contactPerson": "",
          "i__contactSex": "",
          "i__contactTelNo": "",
          "i__contactTelNo2": "",
          "i__contactFaxNo": "",
          "i__contactEmail": "",
          "i__industry": "",
          "i__bizrep": "",
          "i__bizrepIC": "",
          "i__bizrepICValidity": [],
          // "i__bizrepICValidity1": "",
          // "i__bizrepICValidity2": "",
          "i__bizrepLocation": "",
          "i__bizrepICURL1": "",
          "i__bizrepICURL2": "",
          "i__bizrepICURL3": "",
          "i__remarks": ""
        },
        customerId: this.$route.query['c.customerId']||''
      }
    },
    components: {
      ButtonBack,
      Panel,
      CompanyEditComponent,
      FormBuild
    },
    methods: {
      onSubmit: function ($refs) {
        $refs.validate((valid) => {
          if (valid) {
            this.debtorForm.c__customerCode = this.debtorForm.i__socialIdentityCode
            this.debtorForm.i__province = CodeToText[this.debtorForm.i__provinceAndCity[0]]||''
            this.debtorForm.i__city = CodeToText[this.debtorForm.i__provinceAndCity[1]]||''
            xhr.updateDebtor(this.debtorForm, res=>{
              try {
                if(res.data.status == 'success') {
                  this.$router.push({
                    name: 'CustomerAdminDebtorList'
                  })
                }
              }catch (e) {

              }
            })
          }
        })
      },
      getDebtorDetail: function (customerId) {
        xhr.getDebtorDetail({
          'c.customerId' : customerId
        }, res=>{
          try {
            if( res.data.status == 'success') {
              this.debtorForm = res.data.data

              let provinceAndCityArray = [
                TextToCode[this.debtorForm.i__province],
                TextToCode[this.debtorForm.i__province][this.debtorForm.i__city]
              ]
              this.debtorForm.i__provinceAndCity = provinceAndCityArray.map(item=>item.code)

            }
          }catch (e) {

          }
        })
      }
    },
    mounted() {
      if( this.customerId ) {
        this.getDebtorDetail( this.customerId )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/DebtorEdit.vue